import React, { useState } from 'react';
import tenants from '../../Data/saas/generated/tenants.json';

const ROLES = ['student', 'teacher', 'admin'];

export default function AuthSim({ onLogin }) {
  const [role, setRole] = useState('student');
  const [tenantId, setTenantId] = useState(tenants[0]?.tenantId);
  const [userId, setUserId] = useState('');

  const tenantOptions = useState(() => tenants.map(t => ({ id: t.tenantId, name: `${t.name} (${t.schoolCode})` })), []);

  return (
    <div style={{ padding: 16, display: 'grid', gap: 8 }}>
      <h3 style={{ margin: 0 }}>Login (Simulated)</h3>
      <label>
        Role:
        <select value={role} onChange={e => setRole(e.target.value)} style={{ marginLeft: 8 }}>
          {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
        </select>
      </label>
      <label>
        School:
        <select value={tenantId} onChange={e => setTenantId(e.target.value)} style={{ marginLeft: 8 }}>
          {tenantOptions.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
      </label>
      <label>
        User Id (studentId/teacherId or admin email):
        <input value={userId} onChange={e => setUserId(e.target.value)} placeholder="tn_xx-s0001 or tn_xx-t001" style={{ marginLeft: 8 }} />
      </label>
      <button onClick={() => onLogin({ role, tenantId, userId })} style={{ padding: '8px 12px' }}>Login</button>
    </div>
  );
}



